import { AMC_CATEGORY_LIST_AMC_DATA, AMC_CATEGORY_LIST_AMC_ERROR, AMC_CATEGORY_LIST_AMC_HIDE_ERROR, AMC_CATEGORY_LIST_AMC_START_LOADER, AMC_CATEGORY_LIST_AMC_STOP_LOADER } from "../interface/iAmcCategoryListAmc";
const initialState = {
    data: [],
    errorData: { error: null, isOpen: false },
    loader: false,
};
const amcCategoryListAmcReducer = (state = initialState, action) => {
    switch (action.type) {
        case AMC_CATEGORY_LIST_AMC_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case AMC_CATEGORY_LIST_AMC_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case AMC_CATEGORY_LIST_AMC_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case AMC_CATEGORY_LIST_AMC_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case AMC_CATEGORY_LIST_AMC_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default amcCategoryListAmcReducer;
